import React from "react";

interface Props {
  session: server.dto.ClientOnboardingSession
}

const WaitingForSystemOneToCreateAccount = (_: Props) => {
  return <>
    Thank you. We will set up your account and contact you as soon as possible.
  </>;
};

export default WaitingForSystemOneToCreateAccount;